<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import { CELLULITE_GRADE_OPTIONS, findCelluliteGrade, type CelluliteGradeValue } from '../../types/cellulite-grade'

    export let label: string
    export let data: Record<string, any>
    export let value: CelluliteGradeValue = null
    export let required = false
    export let readOnly = false

    function select(key: string) {
        if (readOnly) return
        value = key
    }

    $: selectedOption = findCelluliteGrade(value)
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="cellulite-scale">
        {#each CELLULITE_GRADE_OPTIONS as option (option.key)}
            <button
                type="button"
                class="cellulite-row"
                class:selected={value === option.key}
                disabled={readOnly}
                on:click={() => select(option.key)}
            >
                <span class="cellulite-label">
                    {option.label}
                    <span class="cellulite-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
                <span class="cellulite-desc">{option.description}</span>
            </button>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .cellulite-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .cellulite-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        padding: 10px 14px;
        border: none;
        border-radius: 8px;
        background: #f8f9fa;
        font: inherit;
        text-align: left;
        cursor: pointer;
    }
    .cellulite-row:disabled {
        cursor: not-allowed;
    }
    .cellulite-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .cellulite-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .cellulite-row.selected .cellulite-label {
        color: #1f2937;
    }
    .cellulite-desc {
        flex: 2;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .cellulite-row.selected .cellulite-desc {
        color: #1f2937;
    }
    .cellulite-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .cellulite-row.selected .cellulite-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
